import { styled } from "@mui/material/styles";

export const Label = styled("span")(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: "13px",
  lineHeight: "24px",
  cursor: "pointer",
}));
